import clsx from "clsx";
import { useSaveSingleColor } from "../../save-single-color";
import { SharedIcon } from "../shared/shared-icon";

export function SaveSingleColorButton({
  isSaved = false,
  isLoading = false,
  toggleClickHandler = () => {},
  ...props
}) {
  const { saveColorLabel, removeColorLabel, isButtonBright } =
    useSaveSingleColor();
  const iconId = isLoading
    ? "#sprite-spinner"
    : isSaved
    ? "#sprite-heart-full"
    : "#sprite-heart";

  return (
    <button
      type="button"
      className={clsx(
        "save-single-color-button save-single-color-button--mt-16",
        {
          "save-single-color-button--grey": isButtonBright,
        }
      )}
      onClick={(e) => {
        e.stopPropagation();
        toggleClickHandler();
      }}
      {...props}
    >
      <SharedIcon
        iconName={iconId}
        className={clsx("", { "animate-spin": isLoading })}
      />
      {!isLoading && <span>{isSaved ? removeColorLabel : saveColorLabel}</span>}
    </button>
  );
}
